<div *ngIf="!isDesktop" style="margin-bottom:16px">
  <button class="nnb-btn-block nnb-btn-sm nnb-btn-secondary" (click)="showMenu()">
    <span *ngIf="!isShowMenu">목록 보기</span>
    <span *ngIf="isShowMenu">목록 숨기기</span>
  </button>
</div>

<!-- 미리보기 토글 버튼 -->
<div class="preview-toggle-container" *ngIf="isDesktop">
  <button class="nnb-btn-md nnb-btn-outline preview-toggle-btn" (click)="togglePreview()">
    <span *ngIf="!showPreview">📱 미리보기</span>
    <span *ngIf="showPreview">미리보기 숨기기</span>
  </button>
</div>

<div class="container-fluid px-0">
<div class="row" [class.preview-mode]="showPreview && isDesktop">
  <!-- 상품 속성 메뉴 -->
  <!-- d-none으로 숨김(DOM 유지): bs-stepper가 생성 시점에 .step 노드를 수집해야 모바일에서 _steps 빈배열 크래시 방지 -->
  <div class="col-lg-2 col-md-3 col-sm-12 step-col" [class.d-none]="!(isShowMenu || isDesktop)">
    <div class="step" data-target="#test-l-1">
      <button class="step-trigger"
        [ngStyle]="{'color': formGroup.controls.title.valid && formGroup.controls.hashtags.valid ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.title.valid && formGroup.controls.hashtags.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        상품 이름
      </button>
    </div>
    <div class="step" data-target="#test-l-2">
      <button class="step-trigger" [ngStyle]="{'color': formGroup.controls.photos.valid ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.photos.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        대표 이미지
      </button>
    </div>
    <div class="step" data-target="#test-l-3">
      <button class="step-trigger" (click)="dispatch()" [ngStyle]="{'color': formGroup.controls.address.valid &&
      formGroup.controls.detailAddress.valid &&
      formGroup.controls.howToCome.valid &&
      formGroup.controls.runningDays.valid &&
      formGroup.controls.runningHours.valid &&
      formGroup.controls.runningMinutes.valid
      ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.address.valid &&
          formGroup.controls.detailAddress.valid &&
          formGroup.controls.howToCome.valid &&
          formGroup.controls.runningDays.valid &&
          formGroup.controls.runningHours.valid &&
          formGroup.controls.runningMinutes.valid
          ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        장소/소요시간
      </button>
    </div>
    <div class="step" data-target="#test-l-4">
      <button class="step-trigger"
        [ngStyle]="{'color': formGroup.controls.price.valid ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.price.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        가격
      </button>
    </div>
    <div class="step" data-target="#test-l-5">
      <button class="step-trigger" [ngStyle]="{'color': (this.formGroup.value.version === 1 ?
      this.formGroup.controls.point.valid &&
      this.formGroup.controls.recommend.valid &&
      this.formGroup.controls.description.valid &&
      this.formGroup.controls.courses.valid :
      this.formGroup.controls.recommend.valid &&
      this.formGroup.controls.description.valid &&
      this.formGroup.controls.summaries.valid &&
      this.formGroup.controls.sections.valid &&
      this.formGroup.controls.courses.valid) ? '#8E46EC':''}">
        <img [src]="(this.formGroup.value.version === 1 ?
        this.formGroup.controls.point.valid &&
        this.formGroup.controls.recommend.valid &&
        this.formGroup.controls.description.valid &&
        this.formGroup.controls.courses.valid :
        this.formGroup.controls.recommend.valid &&
        this.formGroup.controls.description.valid &&
        this.formGroup.controls.summaries.valid &&
        this.formGroup.controls.sections.valid &&
        this.formGroup.controls.courses.valid) ? '/assets/new/check-purple.svg':
          '/assets/new/gray.svg'" alt="완료 여부 아이콘">
        소개
      </button>
    </div>
    <div class="step" data-target="#test-l-6">
      <button class="step-trigger"
        [ngStyle]="{'color': formGroup.controls.checkList.valid && formGroup.controls.includeList.valid && formGroup.controls.excludeList.valid ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.checkList.valid && formGroup.controls.includeList.valid && formGroup.controls.excludeList.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        준비물
      </button>
    </div>
    <div class="step" data-target="#test-l-7">
      <button class="step-trigger" [ngStyle]="{'color': formGroup.controls.notice.valid ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.notice.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        유의사항
      </button>
    </div>
    <div class="step" data-target="#test-l-8">
      <button class="step-trigger" [ngStyle]="{'color': formGroup.controls.refundPolicy.valid ? '#8E46EC':''}">
        <img
          [src]="formGroup.controls.refundPolicy.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        환불 정책
      </button>
    </div>
    <div class="step" data-target="#test-l-9">
      <button class="step-trigger" (click)="lastCheck()" [disabled]="formGroup.invalid"
        [ngStyle]="{
          'cursor': formGroup.invalid ? 'not-allowed' : 'pointer',
          'color': formGroup.valid ? '#8E46EC' : ''
        }">
        <img
          [src]="formGroup.valid ? '/assets/new/check-purple.svg':'/assets/new/gray.svg'" alt="완료 여부 아이콘">
        최종 확인
      </button>
    </div>
  </div>
  <!-- 상품 속성 편집 -->
  <div class="col-lg-8 col-md-9 col-sm-12" [class.with-preview]="showPreview && isDesktop">
    <div class="bs-stepper-content" [class.content-with-preview]="showPreview && isDesktop">
      <form [formGroup]="formGroup">
        <!-- 연락처 미인증 안내: 검수 결과 알림톡이 host_info.mobile로만 나가 서버가 검수 요청을 막는다.
             실패 후 팝업만으로는 필수 항목을 다 채운 뒤에야 알게 되므로 버튼 옆에 미리 띄운다.
             검수 대기 중(취소 버튼만 노출)에는 요청할 일이 없어 숨긴다. -->
        <!-- 게이트가 자체 live region 을 들고 있어 여기에 role="status" 를 겹쳐 두면 선택을 바꿀
             때마다 서브트리 전체가 다시 낭독된다. -->
        <div *ngIf="showsReviewBlockers">
          <div *ngIf="!isMobileVerified" role="status"
            style="margin-bottom: 16px; padding: 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px;">
            <p style="margin: 0; font-size: 0.875rem; font-weight: 500; color: #7f1d1d;">검수를 요청하려면 휴대폰 번호 인증이 필요합니다</p>
            <p style="margin: 4px 0 0; font-size: 0.8125rem; color: #991b1b;">
              검수 접수와 승인·반려 결과를 카카오톡으로 안내해 드리기 때문에, 인증된 번호가 없으면 검수를 요청할 수 없습니다.
            </p>
            <button type="button" class="host-mobile-verify-link" (click)="onVerifyMobileEvent.emit()"
              style="display: inline-flex; align-items: center; min-height: 44px; margin-top: 12px; padding: 8px 16px; background: #fff; border: 1px solid #ef4444; border-radius: 6px; font-size: 0.875rem; color: #b91c1c; cursor: pointer;">
              휴대폰 번호 인증하기
            </button>
          </div>

          <!-- 일정이 없거나 전부 꺼진 상태를 갈라 안내하고, 켜는 것까지 여기서 끝낸다(NNB-1095) -->
          <app-review-ticket-gate
            [productId]="productId"
            [hasReservableTicket]="hasReservableTicket"
            [reservationHours]="productReservationHours"
            (reservableChange)="onReservableChangeEvent.emit()"
          ></app-review-ticket-gate>
        </div>

        <!-- 이전/다음 및 저장/검수요청 버튼 -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; padding: 12px; background: #f8f9fa; border-radius: 8px; flex-wrap: wrap; gap: 8px;">
          <div style="display: flex; gap: 8px; align-items: center;">
            <button class="nnb-btn-secondary nnb-btn-md" (click)="prev()" [disabled]="currentStep === 0">이전</button>
            <button class="nnb-btn-md nnb-btn-primary" (click)="next()" *ngIf="currentStep < 8">다음</button>
          </div>
          <div style="display: flex; gap: 12px; align-items: center;">
            <!-- 저장 성공 메시지 또는 자동 저장 시간 표시 -->
            <div *ngIf="lastAutoSaved" style="font-size: 13px; color: #666;">
              {{ getRelativeTime(lastAutoSaved) }}
            </div>
            <button class="nnb-btn-md"
              [ngClass]="(isAdminPage || hasUnsavedChanges) ? 'nnb-btn-primary' : 'nnb-btn-outline'"
              [disabled]="isLoad || formGroup.invalid || (!isAdminPage && hasUnsavedChanges === false)"
              (click)="isAdminPage ? add() : onSaveEvent.emit()">
              {{ hasUnsavedChanges ? '저장' : (isAdminPage ? '저장' : '저장됨') }}
            </button>
            <button *ngIf="!isAdminPage && productStatus !== ProductStatus.ENTERED"
              class="nnb-btn-md"
              [ngClass]="productStatus === ProductStatus.PENDING_REVIEW ? 'nnb-btn-secondary' : 'nnb-btn-primary'"
              [disabled]="formGroup.invalid || isLoad"
              (click)="onRequestReviewEvent.emit()">
              {{ productStatus === ProductStatus.PENDING_REVIEW ? '검수 취소' : '검수 요청' }}
            </button>
          </div>
        </div>
        <!-- 상품제목 -->
        <div id="test-l-1" class="content">
          <notion-desc [description]="descriptions[0]"></notion-desc>
          <form-input [name]="'상품 이름'" [controlName]="'title'" [group]="formGroup" [maxLength]="50"
            [errors]="[{key:'maxlength',message:'50자 제한입니다.'}]" [placeholder]="'상품 이름을 작성해주세요.'"></form-input>
          <div style="height:16px"></div>
          <form-input [name]="'태그'" [controlName]="'hashtags'" [group]="formGroup" [type]="'select'"
            [selectList]="hashtags" [multiple]="true" [addTag]="addTag" [template]="hashtagTpl" [valueProp]="'id'"
            (searchEvent)="checkHashtag($event)" [maxSelectedItems]="8">
          </form-input>
          <div class="desc">최대 8개까지 등록 가능합니다.</div>
          <ng-template #hashtagTpl let-element>
            {{ element.name }}
          </ng-template>
          <ng-container *ngIf="canSelectThemes">
            <div style="height:24px"></div>
            <div class="input-label" style="margin-bottom: 16px;">테마</div>
            <theme-picker [selectedIds]="themeIds" (selectedIdsChange)="themeIdsChange.emit($event)"></theme-picker>
          </ng-container>
        </div>
        <!-- 대표이미지 -->
        <div id="test-l-2" class="content">
          <notion-desc [description]="descriptions[1]"></notion-desc>
          <div class="input-label" style="margin-bottom: 16px;">
            상품 이미지&nbsp;<span class="invalid-input">(필수)</span>
          </div>
          <!-- AI 편집은 미리보기에서 제공, 업로드는 form-input으로 통일 -->
          <form-input [name]="''" [controlName]="'photos'" [isRequired]="false" [group]="formGroup" [maxPhotos]="8"
            [type]="'photo'" (imageCroppedEvent)="imageCropped($event)" [croppedImageForModal]="croppedImage"
            [converter]="toProductRepresentationPhotoCreateDto" [canGif]="false">
          </form-input>
          <hr style="margin-top:15px">
        </div>
        <!-- 장소/소요시간 -->
        <div id="test-l-3" class="content">
          <notion-desc [description]="descriptions[2]"></notion-desc>
          <product-boarding *ngIf="productId" [productId]="productId"></product-boarding>

          <form-input [name]="'주소'" [controlName]="'address'" [group]="formGroup" [type]="'map'" [latitude]="latitude"
            [longitude]="longitude" [id]="random" [mapOption]="{draggable:false,scrollWheel:false}"
            [placeholder]="'도로명/지번주소 입력 후 검색'" (mapSearchEvent)="searchMap($event)">
          </form-input>
          <div style="height:16px"></div>
          <form-input [name]="'상세 장소'" [controlName]="'detailAddress'" [group]="formGroup" [maxLength]="500"
            [placeholder]="'상세 장소를 작성해주세요.'" [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]"></form-input>
          <div style="height:16px"></div>
          <form-input [name]="'오는 방법'" [controlName]="'howToCome'" [type]="'textarea'" [group]="formGroup"
            [placeholder]="'(선택사항) 오는 방법을 작성해주세요.'" [errors]="[{key:'maxlength',message:'1000자 제한입니다.'}]"
            [maxLength]="1000" [rows]="5" [isRequired]="false">
          </form-input>
          <div style="height:16px"></div>
          <div style="display: flex;align-items: center;">
            <div style="display: flex;align-items: flex-end;">
              <form-input [name]="'상품 진행시간'" [controlName]="'runningDays'" [group]="formGroup" [type]="'select'"
                [selectList]="days" [clearable]="false">
              </form-input>
              <p style="margin-left: 6px;">일</p>
            </div>
            <div style="display: flex;align-items: flex-end;margin-top:24px">
              <form-input [name]="''" [controlName]="'runningHours'" [group]="formGroup" [type]="'select'"
                [selectList]="hours" [clearable]="false">
              </form-input>
              <p style="margin-left: 6px;">시간</p>
            </div>
            <div style="display: flex;align-items: flex-end;margin-top:24px">
              <form-input [name]="''" [controlName]="'runningMinutes'" [group]="formGroup" [type]="'select'"
                [selectList]="minutes" [clearable]="false">
              </form-input>
              <p style="margin-left: 6px;">분</p>
            </div>
          </div>
          <hr>
          <div class="desc">
            예를 들어 1박2일의 경우 2일, 2박3일의 경우 3일 입력합니다. 하루 내에 진행되는 상품은 시간/분만 입력하시면 됩니다.</div>
          <div style="height:16px"></div>
          <div style="display: flex;align-items: flex-end;margin-top:24px">
            <form-input [name]="'예약 가능 시간'" [controlName]="'reservationHours'" [group]="formGroup" [type]="'select'"
              [selectList]="reservationHours" [valueProp]="'value'" [labelProp]="'label'" [clearable]="false">
            </form-input>
            <p style="margin-left: 6px;">전까지</p>
          </div>

          <p class="desc">최소 몇 시간 전까지 예약을 받을 수 있는지 입력합니다.<br />마감 시간을 늘리면(예: 6시간 →
            240시간) 시작이 임박한 회차는 예약이 마감 처리될 수 있어요.</p>

          <!-- 예약 방식: 어드민 상품 수정 화면 전용(showBookingMode) -->
          <div *ngIf="showBookingMode" style="margin-top:16px">
            <div class="input-label">예약 방식</div>
            <mat-radio-group formControlName="bookingMode" style="display:flex;flex-direction:column;gap:8px;margin-top:8px">
              <mat-radio-button value="INSTANT">즉시 확정</mat-radio-button>
              <mat-radio-button value="APPROVAL">승인 후 확정 (결제 후 호스트 승인, 미승인 시 자동 취소·전액 환불)</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <!-- 가격 -->
        <div id="test-l-4" class="content">
          <notion-desc [description]="descriptions[3]"></notion-desc>
          <form-input [name]="'가격'" [controlName]="'price'" [type]="'tel'" [group]="formGroup"
            [max]="10000000" [placeholder]="'가격을 작성해주세요.'"
            [errors]="[{key:'min',message:'0원 이상이어야 합니다.'},{key:'max',message:'10,000,000원 제한입니다.'},{key:'pattern',message:'숫자만 입력 가능합니다.'}]">
          </form-input>
          <div style="height:16px"></div>
          <!-- productId 가 없으면(등록 화면) formGroup 에 discountCouponId 컨트롤이 없다 — select 를
               그려 FormControlName 이 찾지 못하게 만들면 안 되므로 isAdminPage 만으로 가르지 않는다. -->
          <ng-container *ngIf="isAdminPage && productId; else noCouponPicker">
            <form-input [name]="'할인 쿠폰 지정'" [controlName]="'discountCouponId'" [type]="'select'" [group]="formGroup"
              [selectList]="discountCouponSelectOptions" [valueProp]="'id'" [labelProp]="'label'" [clearable]="false"
              [isUnUseDirty]="false" [isRequired]="false">
            </form-input>
            <p class="desc" *ngIf="discountCandidatesLoading">쿠폰 목록을 불러오는 중입니다…</p>
            <p class="desc" *ngIf="!discountCandidatesLoading && !discountCandidatesFailed && discountCouponCandidates.length === 0">
              이 상품에 연결된 쿠폰이 없습니다. 쿠폰 관리 화면에서 먼저 연결해 주세요.
            </p>
            <p class="desc" *ngIf="discountCandidatesFailed">쿠폰 목록을 불러오지 못했어요. 다시 시도해 주세요.</p>
          </ng-container>
          <ng-template #noCouponPicker>
            <p class="desc" *ngIf="isAdminPage">상품을 저장한 뒤 쿠폰을 연결하면 지정할 수 있어요.</p>
            <p class="desc" *ngIf="!isAdminPage">할인 쿠폰 지정은 운영팀이 관리해요. 이 상품에 연결된 쿠폰이 있으면 자동으로 가장 유리한 할인이 적용돼요.</p>
          </ng-template>
          <br>
          <p class="desc" style="margin: 0px;">다음과 같이 표시됩니다.</p>
          <div class="preview-price">
            <price *ngIf="formGroup.controls.price.valid"
              [price]="+formGroup.controls.price.value"
              [discountPrice]="selectedDiscountPreviewPrice ?? undefined">
            </price>
          </div>
        </div>
        <!-- 소개 -->
        <div id="test-l-5" class="content">
          <notion-desc [description]="descriptions[4]"></notion-desc>

          <!-- v1 로 되돌리는 버튼은 없앴다. 이 버튼은 폼만 비우고 v2 컨트롤을 연다 — 보관본을
               만들거나 복원하지 않는다. 남은 v1 상품 내용을 옮기려면 '(V2 강제변환)' 을 복원하고,
               변환 전 원본이 필요하면 그보다 먼저 만들어진 v1 보관본을 복원한다. -->
          <div *ngIf="isAdmin && formGroup.value.version === 1"
            style="padding:16px;border-radius: 8px;border: 1px solid #d8d8d8;margin-bottom: 32px;">
            <div style="font-size: 16px;font-weight: 600;margin-bottom: 8px;">관리자 전용 도구</div>
            <div style="display: flex;gap:8px;">
              <button class="nnb-btn-md nnb-btn-outline" (click)="convertToV2()">버전2로 소개 작성하기</button>
            </div>
            <div class="desc" style="margin-top:8px;">
              누르면 기존 상세 내용이 사라집니다. 내용을 옮기려면 보관 목록의 "(V2 강제변환)"을 복원해주세요.
            </div>
          </div>

          <div *ngIf="formGroup.value.version===1" class="input-label">
            상세&nbsp;<span class="invalid-input">(필수)</span>
          </div>

          <div *ngIf="formGroup.value.version===2" class="input-label">기타 정보</div>
          <div class="desc">상세페이지 상단 유튜브 영상 또는 공지 사항 등 강조하고 싶은 정보를 작성해주세요.</div>

          <ng-container *ngIf="useRawHtmlEditor; else quillDescription">
            <div class="rich-html-guard">
              <strong>이 상세 설명은 HTML 로 만들어져 있습니다.</strong>
              Quill 편집기로 저장하면 표·박스·정렬 같은 구성이 사라지고 글자만 남습니다.
              그래서 원문(HTML)으로 편집합니다.
              <button type="button" class="link-btn" (click)="useQuillForDescription()">
                그래도 Quill 로 편집
              </button>
            </div>
            <textarea class="rich-html-source" formControlName="description" rows="18" spellcheck="false"
              placeholder="상세 설명 HTML" aria-label="상세 설명 HTML 원문"></textarea>
          </ng-container>

          <ng-template #quillDescription>
            <dynamic-quill-editor [ngClass]="{'version2-description':formGroup.value.version===2}" #quill
              [editorStyle]="'-webkit-user-select: text'" formControlName="description"
              [placeholder]="formGroup.value.version===1 ? '프로그램 소개를 작성해주세요':'기타 정보를 작성해주세요'"
              [showToolbar]="true"
              (onEditorCreated)="fileUploadService.getEditorInstance($event,quill,'meetings')">
            </dynamic-quill-editor>
          </ng-template>
          <div style="height:32px"></div>

          <ng-container *ngIf="formGroup.value.version===1">
            <form-input [name]="'포인트'" [controlName]="'point'" [type]="'textarea'" [group]="formGroup"
              [placeholder]="'포인트를 작성해주세요.'" [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500">
            </form-input>
            <div style="height:32px"></div>
            <form-input [name]="'추천 성향'" [controlName]="'recommend'" [type]="'textarea'" [group]="formGroup"
              [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [placeholder]="'추천 성향을 작성해주세요.'" [maxLength]="500">
            </form-input>
          </ng-container>

          <ng-container *ngIf="formGroup.value.version===2">
            <form-input [name]="'추천 성향'" [controlName]="'recommend'" [type]="'textarea'" [group]="formGroup"
              [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500">
            </form-input>
            <div style="height:32px"></div>
            <div class="input-label">
              상세요약&nbsp;<span class="invalid-input">(필수)</span>
            </div>
            <div class="desc">상세요약 이미지 권장 사이즈는 높이 180px입니다.</div>
            <div formArrayName="summaries">
              <div *ngFor="let summary of getSummary().controls; let index = index;let last=last;">
                <div [formGroupName]="index" style="display:flex;gap:8px">
                  <div style="width:24px">
                    <img *ngIf="index==0"
                      [src]="'/assets/new/simple-arrow-up-grey.svg'" alt="위로 이동 불가">
                    <img *ngIf="index!=0" style="cursor: pointer;" (click)="moveUp(index, 'summaries')"
                      [src]="'/assets/new/simple-arrow-up.svg'" alt="위로 이동">
                    <img *ngIf="!last" style="cursor: pointer;" (click)="moveDown(index, 'summaries')"
                      [src]="'/assets/new/simple-arrow-down.svg'" alt="아래로 이동">
                    <img *ngIf="last"
                      [src]="'/assets/new/simple-arrow-down-grey.svg'" alt="아래로 이동 불가">
                  </div>
                  <div style="width:100%;padding:15px;border: 1px solid #E8E8EF;border-radius: 6px;">
                    <div style="display:flex;justify-content: space-between;align-items: center;margin-bottom: 4px;">
                      <div class="nnb-badge nnb-badge-sm nnb-badge-purple">요약 {{ index+1| number:'2.0' }}</div>
                      <button *ngIf="index!=0" class="nnb-btn-sm" (click)="removeSummary(index)" aria-label="요약 삭제">삭제</button>
                    </div>
                    <!-- AI 편집은 미리보기에서 제공, 업로드는 form-input으로 통일 -->
                    <form-input [name]="''" [controlName]="'photos'" [type]="'photo'"
                      [group]="getSummary().controls[index]" [maxPhotos]="1" [multiplePhoto]="false"
                      [converter]="toProductRepresentationPhotoCreateDto" [canGif]="false"
                      [maintainAspectRatio]="false" [isRequired]="false">
                    </form-input>
                    <div style="height:6px"></div>
                    <form-input [name]="''" [controlName]="'title'" [group]="getSummary().controls[index]"
                      [errors]="[{key:'maxlength',message:'50자 제한입니다.'}]" [maxLength]="50" [placeholder]="'제목을 입력해주세요.'">
                    </form-input>
                    <div style="height:6px"></div>
                    <form-input [name]="''" [controlName]="'description'" [group]="getSummary().controls[index]"
                      [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500"
                      [placeholder]="'요약 내용을 입력해주세요.'">
                    </form-input>
                  </div>
                </div>
                <div style="height: 10px;"></div>
              </div>
            </div>
            <button class="nnb-btn-md nnb-btn-secondary nnb-btn-block" (click)="addSummary()">요약 추가</button>
            <div style="height:32px"></div>
            <div class="input-label">
              상세&nbsp;<span class="invalid-input">(필수)</span>
            </div>
            <div formArrayName="sections">
              <div *ngFor="let section of getSection().controls; let sectionIndex = index; let sectionLast = last;">
                <div [formGroupName]="sectionIndex" style="display:flex;gap:8px;">
                  <div style="width:24px">
                    <img *ngIf="sectionIndex==0"
                      [src]="'/assets/new/simple-arrow-up-grey.svg'" alt="위로 이동 불가">
                    <img *ngIf="sectionIndex!=0" style="cursor: pointer;" (click)="moveUp(sectionIndex, 'sections')"
                      [src]="'/assets/new/simple-arrow-up.svg'" alt="위로 이동">
                    <img *ngIf="!sectionLast" style="cursor: pointer;" (click)="moveDown(sectionIndex, 'sections')"
                      [src]="'/assets/new/simple-arrow-down.svg'" alt="아래로 이동">
                    <img *ngIf="sectionLast"
                      [src]="'/assets/new/simple-arrow-down-grey.svg'" alt="아래로 이동 불가">
                  </div>
                  <div style="width:100%;padding:15px;border: 1px solid #E8E8EF;border-radius: 6px;">
                    <div style="display:flex;justify-content: space-between;align-items: center;margin-bottom: 4px;">
                      <div class="nnb-badge nnb-badge-sm nnb-badge-purple">섹션 {{ sectionIndex+1| number:'2.0' }}</div>
                      <button *ngIf="sectionIndex!=0" class="nnb-btn-sm"
                        (click)="removeSection(sectionIndex)" aria-label="섹션 삭제">삭제</button>
                    </div>
                    <form-input [name]="''" [controlName]="'title'" [group]="getSection().controls[sectionIndex]"
                      [errors]="[{key:'maxlength',message:'50자 제한입니다.'}]" [maxLength]="50"
                      [placeholder]="'섹션 제목을 입력해주세요.'">
                    </form-input>
                    <hr style="margin: 16px 0px">
                    <div formArrayName="paragraphs">
                      <div
                        *ngFor="let paragraph of getParagraph(sectionIndex).controls; let paragraphIndex = index; let paragraphLast=last">
                        <div [formGroupName]="paragraphIndex" style="display:flex;gap:8px;">
                          <div style="width:24px">
                            <img *ngIf="paragraphIndex==0"
                              [src]="'/assets/new/simple-arrow-up-grey.svg'" alt="위로 이동 불가">
                            <img *ngIf="paragraphIndex!=0" style="cursor: pointer;"
                              (click)="moveUp2(sectionIndex, paragraphIndex, 'paragraphs')"
                              [src]="'/assets/new/simple-arrow-up.svg'" alt="위로 이동">
                            <img *ngIf="!paragraphLast" style="cursor: pointer;"
                              (click)="moveDown2(sectionIndex, paragraphIndex, 'paragraphs')"
                              [src]="'/assets/new/simple-arrow-down.svg'" alt="아래로 이동">
                            <img *ngIf="paragraphLast"
                              [src]="'/assets/new/simple-arrow-down-grey.svg'" alt="아래로 이동 불가">
                          </div>
                          <div style="width:100%;">
                            <div style=" display:flex;justify-content: space-between;align-items: center;margin-bottom:
                            4px;">
                              <div class="nnb-badge nnb-badge-sm nnb-badge-light-grey">문단 {{ paragraphIndex+1|
                                number:'2.0' }}
                              </div>
                              <button *ngIf="paragraphIndex!=0" class="nnb-btn-sm"
                                (click)="removeParagraph(sectionIndex,paragraphIndex)" aria-label="문단 삭제">삭제</button>
                            </div>
                            <form-input [name]="''" [controlName]="'title'"
                              [group]="getParagraph(sectionIndex).controls[paragraphIndex]"
                              [errors]="[{key:'maxlength',message:'50자 제한입니다.'}]" [maxLength]="50"
                              [placeholder]="'문단의 제목을 입력해주세요.'" [ngStyle]="{'min-width': isDesktop? '200px':''}">
                            </form-input>
                            <div style="height:6px"></div>
                            <form-input [name]="''" [controlName]="'time'"
                              [group]="getParagraph(sectionIndex).controls[paragraphIndex]"
                              [errors]="[{key:'maxlength',message:'50자 제한입니다.'}]" [maxLength]="50"
                              [placeholder]="'(선택사항) 14:00 ~ 2시간 / 시작시간 ~ 소요시간을 입력해주세요.'"
                              [ngStyle]="{'min-width': isDesktop? '200px':''}">
                            </form-input>
                            <div style="height:6px"></div>
                            <!-- AI 편집은 미리보기에서 제공, 업로드는 form-input으로 통일 -->
                            <form-input [name]="''" [controlName]="'photos'" [type]="'photo'"
                              [group]="getParagraph(sectionIndex).controls[paragraphIndex]" [maxPhotos]="10"
                              [converter]="toProductRepresentationPhotoCreateDto" [canGif]="false"
                              [maintainAspectRatio]="false" [isRequired]="false">
                            </form-input>
                            <div style="height:6px"></div>
                            <form-input [name]="''" [controlName]="'description'" [type]="'textarea'" [rows]="5"
                              [group]="getParagraph(sectionIndex).controls[paragraphIndex]"
                              [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500" [placeholder]="'내용을 입력해주세요.'"
                              style="width:100%">
                            </form-input>
                            <form-input [name]="''" [controlName]="'note'" [type]="'textarea'" [rows]="1"
                              [group]="getParagraph(sectionIndex).controls[paragraphIndex]"
                              [errors]="[{key:'maxlength'}]" [maxLength]="0"
                              [placeholder]="'(선택사항) 추가 또는 강조 내용을 입력해주세요.'" style="width:100%">
                            </form-input>
                          </div>
                        </div>
                        <hr style="margin: 16px 0px" *ngIf="!paragraphLast">
                      </div>
                    </div>
                    <button class="nnb-btn-outline nnb-btn-md nnb-btn-block" (click)="addParagraph(sectionIndex)">문단
                      추가</button>
                  </div>
                  <div style="height: 10px;"></div>
                </div>
                <div *ngIf="!sectionLast" style="height: 10px;"></div>
              </div>
            </div>
            <div style="height: 10px;"></div>
            <button class="nnb-btn-md nnb-btn-secondary nnb-btn-block" (click)="addSection()">섹션 추가</button>
          </ng-container>
          <div style="height:32px"></div>
          <div class="input-label">
            일정
          </div>
          <div formArrayName="courses">
            <div *ngFor="let course of getCourse().controls; let courseIndex = index;">
              <div [formGroupName]="courseIndex" style="padding:15px;border: 1px solid #0000001a;border-radius: 6px;">
                <div style="display:flex;justify-content: space-between;align-items: center;margin-bottom: 4px;">
                  <div class="nnb-badge nnb-badge-sm nnb-badge-purple">일정 {{ courseIndex+1| number:'2.0' }}</div>
                  <button class="nnb-btn-sm" (click)="removeCourse(courseIndex)" aria-label="일정 삭제">삭제</button>
                </div>
                <form-input [name]="''" [controlName]="'title'" [group]="getCourse().controls[courseIndex]"
                  [errors]="[{key:'maxlength',message:'20자 제한입니다.'}]" [maxLength]="20"
                  [placeholder]="'첫째날/둘째날/1일차/2일차 등 일정 제목을 입력해주세요.'">
                </form-input>
                <hr style="margin: 15px 0px">
                <div formArrayName="schedules">
                  <div *ngFor="let schedule of getSchedule(courseIndex).controls; let scheduleIndex = index;">
                    <div [formGroupName]="scheduleIndex">
                      <div style="display:flex;justify-content: space-between;align-items: center;margin-bottom: 4px;">
                        <div class="nnb-badge nnb-badge-sm nnb-badge-light-grey">항목 {{ scheduleIndex+1| number:'2.0' }}
                        </div>
                        <button *ngIf="scheduleIndex!=0" class="nnb-btn-sm"
                          (click)="removeSchedule(courseIndex,scheduleIndex)" aria-label="항목 삭제">삭제</button>
                      </div>
                      <form-input [name]="''" [controlName]="'subTitle'"
                        [group]="getSchedule(courseIndex).controls[scheduleIndex]"
                        [errors]="[{key:'maxlength',message:'20자 제한입니다.'}]" [maxLength]="0"
                        [placeholder]="'14:00 ~ 2시간 / 시작시간 ~ 소요시간을 입력해주세요.'"
                        [ngStyle]="{'min-width': isDesktop? '200px':''}">
                      </form-input>
                      <div style="height: 10px;"></div>
                      <form-input [name]="''" [controlName]="'content'"
                        [group]="getSchedule(courseIndex).controls[scheduleIndex]" [errors]="[{key:'maxlength'}]"
                        [maxLength]="0" [placeholder]="'내용을 입력해주세요.'" style="width:100%">
                      </form-input>
                      <div style="height: 10px;"></div>
                      <form-input [name]="''" [controlName]="'note'" [type]="'textarea'" [rows]="1"
                        [group]="getSchedule(courseIndex).controls[scheduleIndex]" [errors]="[{key:'maxlength'}]"
                        [maxLength]="0" [placeholder]="'(선택사항) 추가 사항을 입력해주세요.'" style="width:100%">
                      </form-input>
                    </div>
                    <div style="height: 10px;"></div>
                  </div>
                </div>
                <button class="nnb-btn-outline nnb-btn-md nnb-btn-block" (click)="addSchedule(courseIndex)">항목
                  추가</button>
              </div>
              <div style="height: 10px;"></div>
            </div>
          </div>
          <button class="nnb-btn-secondary nnb-btn-md nnb-btn-block" (click)="addCourse()">일정 추가</button>
        </div>
        <!-- 준비물 -->
        <div id="test-l-6" class="content">
          <notion-desc [description]="descriptions[5]"></notion-desc>
          <form-input [name]="'준비물'" [controlName]="'checkList'" [type]="'textarea'" [group]="formGroup"
            [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500" [placeholder]="'준비물을 작성해주세요.'">
          </form-input>
          <div style="height:16px"></div>
          <form-input [name]="'포함 사항'" [controlName]="'includeList'" [type]="'textarea'" [group]="formGroup"
            [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500" [isRequired]="false"
            [placeholder]="'(선택사항) 포함 사항을 작성해주세요.'">
          </form-input>
          <div style="height:16px"></div>
          <form-input [name]="'불포함 사항'" [controlName]="'excludeList'" [type]="'textarea'" [group]="formGroup"
            [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500" [isRequired]="false"
            [placeholder]="'(선택사항) 불포함 사항을 작성해주세요.'">
          </form-input>
          <div style="height:16px"></div>
          <div style="display:flex;gap:10px">
            <div class="input-label">숙소 시설</div>
            <input type="checkbox" (change)="onIsAmenity($event)" [formControlName]="'isAmenity'">
          </div>
          <ng-container *ngIf="formGroup.controls.isAmenity.value">
            <div class="desc">(원하시는 항목이 없는 경우 상품 소개 또는 포함사항에 추가 정보를 기재해주세요.)</div>
            <div style="display: flex;flex-wrap: wrap;">
              <div *ngFor="let amenity of amenities" style="width: 30%;margin: 7px 0px;">
                <input type="checkbox" [value]="amenity.id"
                  [checked]="formGroup.controls.amenities.value.includes(amenity.id)"
                  (change)="onCheckAmenity($event, amenity)" />
                {{ amenity.name }}
              </div>
            </div>
          </ng-container>
        </div>
        <!-- 유의사항 -->
        <div id="test-l-7" class="content">
          <notion-desc [description]="descriptions[6]"></notion-desc>
          <form-input [name]="'유의 사항'" [controlName]="'notice'" [type]="'textarea'" [group]="formGroup"
            [placeholder]="'유의사항을 작성해주세요.'" [errors]="[{key:'maxlength',message:'500자 제한입니다.'}]" [maxLength]="500"
            [isRequired]="false">
          </form-input>

          <div style="display: flex;gap: 6px;align-items: center;">
            <input type="checkbox" [checked]="noticeChecked" (change)="checkAllowPolicy($event)">
            <div>노는법 정책을 따르겠습니다.</div>
          </div>
        </div>
        <!-- 환불정책 -->
        <div id="test-l-8" class="content">
          <notion-desc [description]="descriptions[7]"></notion-desc>
          <div class="input-label">
            환불 정책&nbsp;<span class="invalid-input">(필수)</span>
          </div>
          <form-input [name]="''" [controlName]="'refundPolicy'" [type]="'textarea'" [group]="formGroup"
            [placeholder]="'환불 정책을 작성해주세요.'" [errors]="[{key:'maxlength',message:'1000자 제한입니다.'}]" [maxLength]="1000"
            [rows]="5" [isRequired]="false">
          </form-input>
        </div>
        <!-- 최종확인 -->
        <div id="test-l-9" class="content">
          <notion-desc [description]="descriptions[8]" />
        </div>
      </form>
    </div>
  </div>

  <!-- 미리보기 패널 -->
  <div class="col-lg-4 preview-panel-container" *ngIf="showPreview && isDesktop">
    <div class="preview-panel">
      <div class="preview-panel-header">
        <div class="preview-panel-title">
          <img src="/assets/tossface/u1F4F1.svg" style="width:20px;height:20px" alt="미리보기 아이콘">
          <span>실시간 미리보기</span>
          <span class="update-badge">실시간</span>
        </div>
        <button class="close-panel-btn" (click)="togglePreview()" title="미리보기 닫기" aria-label="미리보기 닫기">
          ✕
        </button>
      </div>

      <div class="preview-content">
        <!-- ProductPreview 컴포넌트 사용 -->
        <meeting-preview [product]="livePreviewData" [isAdminPage]="isAdminPage" (updatePhoto)="handlePhotoUpdate($event)" />

        <!-- 업데이트 상태 -->
        <div class="preview-update-status">
          <div class="update-indicator">
            <span class="update-icon animate-pulse">🔄</span>
            <span class="update-text">실시간으로 업데이트 중...</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
